import React, { useState } from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import {
  Box,
  IconButton,
  Tooltip as MuiTooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);

const OrdendeVentaPerfectaBarChart = () => {
  const [infoOpen, setInfoOpen] = useState(false);

  const labels = [
    'Salud/Farmacéutica',
    'Automotriz',
    'Manufactura',
    'Construcción',
    'Retail',
    'Alimentos',
    'Servicios logísticos',
  ];

  const data2022 = [90, 83, 92 ,90, 90, 91, 89];
  const data2023 = [100, 92, 91, 96, 88, 95, 97];

  const chartData = {
    labels,
    datasets: [
      {
        label: '2022',
        data: data2022,
        backgroundColor: '#1F3D58',
      },
      {
        label: '2023',
        data: data2023,
        backgroundColor: '#717171',
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
        labels: { font: { size: 12, weight: 'bold' } },
      },
      tooltip: {
        callbacks: {
          label: (context) => `${context.dataset.label}: ${context.raw}%`,
        },
      },
      datalabels: {
        anchor: 'end',
        align: 'start',
        formatter: (value) => `${value}%`,
        font: { weight: 'bold' },
        color: '#ffffff',
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        max: 110,
        title: {
          display: true,
          text: 'Porcentaje (%)',
        },
        ticks: {
          stepSize: 10,
        },
      },
      x: {
        title: {
          display: false,
        },
      },
    },
  };

  const infoContent = {
    Analisis:
      'El indicador de Orden de Venta Perfecta muestra una mejora generalizada en 2023, destacando avances sobresalientes en Servicios logísticos, Construcción, Automotriz y especialmente Farmacéuticas, que alcanzó un 100% de cumplimiento.',
    formula:
      'Orden de Venta Perfecta (%) = (Órdenes completas, a tiempo y sin errores / Total de órdenes realizadas) × 100',
    description:
      'Esta gráfica muestra el porcentaje de órdenes de venta perfectas para diferentes industrias durante los años 2022 y 2023. Este indicador mide la eficiencia en la entrega de órdenes completas, a tiempo y sin errores.',
  };

  return (
    <div style={{ width: '100%', maxWidth: '700px', margin: '0 auto' }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <MuiTooltip title="Información de la gráfica">
          <IconButton onClick={() => setInfoOpen(true)}>
            <InfoIcon />
          </IconButton>
        </MuiTooltip>
      </Box>
      <div style={{ width: '100%', height: '400px' }}>
        <Bar data={chartData} options={options} />
      </div>
      <Dialog open={infoOpen} onClose={() => setInfoOpen(false)}>
        <DialogTitle>Información de la Gráfica</DialogTitle>
        <DialogContent>
          <p style={{ whiteSpace: 'pre-line' }}><strong>Análisis:</strong> {infoContent.Analisis}</p>
          <p><strong>Fórmula:</strong> {infoContent.formula}</p>
          <p><strong>Descripción:</strong> {infoContent.description}</p>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setInfoOpen(false)} color="primary">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default OrdendeVentaPerfectaBarChart;
